"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItem = void 0;
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const colors_1 = require("../colors");
exports.StyledListItem = (0, material_1.styled)(ListItem_1.default)(({ theme }) => ({
    slot: "Root",
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    "&:hover": {
        backgroundColor: colors_1.black["900"],
    },
    "& .MuiTouchRipple-child": {
        backgroundColor: "white",
    },
}));
exports.default = exports.StyledListItem;
